const MEDIA_LIBRARY_RESET_STATE = "page::media-library::reset";

const MEDIA_LIBRARY_OPEN_MODAL = "page::media-library::modal::open";
const MEDIA_LIBRARY_CLOSE_MODAL = "page::media-library::modal::close";

const MEDIA_LIBRARY_SELECT = "page::media-library::select";

const MEDIA_LIBRARY_REDIRECT = "page::media-library::redirect";

function selectMediaAction(selected) {
  const payload = { selected };
  return {
    payload,
    type: MEDIA_LIBRARY_SELECT,
  };
}

function resetPageStateAction() {
  return {
    type: MEDIA_LIBRARY_RESET_STATE,
  };
}

function redirectToFolderAction(folderId) {
  return {
    payload: { data: { id: folderId } },
    type: MEDIA_LIBRARY_REDIRECT,
  };
}

function openModalAction(modalKey) {
  return {
    payload: modalKey,
    type: MEDIA_LIBRARY_OPEN_MODAL,
  };
}

const closeModalAction = {
  type: MEDIA_LIBRARY_CLOSE_MODAL,
};

export {
  closeModalAction,
  MEDIA_LIBRARY_CLOSE_MODAL,
  MEDIA_LIBRARY_OPEN_MODAL,
  MEDIA_LIBRARY_REDIRECT,
  MEDIA_LIBRARY_RESET_STATE,
  MEDIA_LIBRARY_SELECT,
  openModalAction,
  redirectToFolderAction,
  resetPageStateAction,
  selectMediaAction,
};
